import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useWindowWidth } from "@react-hook/window-size";
import Loading from "../../Components/Loading/Loading";
import Categories from "../homepage/Components/Categories";
import * as service from "./service";
import AddToPlaylistPopup from "../ShowDetailsScreen/Components/AddToPlaylistPopup";
import Translate, { useTranslateText } from "../../Components/Multilanguage/Translate";
import { rowItemCount } from "../../utils/utils";

function Favorites() {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const user = useSelector((state) => state?.user?.value);
  const myListRedux = useSelector((state) => state?.myList?.value);
  const textTranslate = useTranslateText();
  const windowSize = useWindowWidth();

  const [loading, setLoading] = useState(true);
  const [watchlistData, setWatchlistData] = useState([]);
  const [showDeletePlaylistPopup, setShowDeletePlaylistPopup] = useState(false);
  const [rowItemCountNumber, setRowItemCountNumber] = useState(5);

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  useEffect(() => {
    if (user) {
      fetchWatchlistShows();
    } else {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (myListRedux) {
      setWatchlistData(myListRedux);
    }
  }, [myListRedux]);

  useEffect(() => {
    if (windowSize > 980) {
      const newClass = projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT
        ? rowItemCount(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT)
        : "rowCount4";
      setRowItemCountNumber(parseInt(newClass.replace(/\D/g, ''), 10));
    } else {
      if (windowSize > 767) {
        setRowItemCountNumber(2);
      } else if (windowSize > 319) {
        setRowItemCountNumber(1);
      }
    }
  }, [projectInfo, windowSize]);

  const fetchWatchlistShows = async () => {
    try {
      const response = await service.fetchWatchlistShows(appInfo);
      if (response?.status === 200) {
        setWatchlistData(response?.data?.data);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message, {
        position: "bottom-center",
      });
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className={"homePage"} style={{ paddingTop: "100px" }}>
      <AddToPlaylistPopup
        isOpen={showDeletePlaylistPopup}
        onClose={() => {
          setShowDeletePlaylistPopup(false);
        }}
        type="delete"
      />
      <div className="favorites-header-button" title={textTranslate("delete_playlist")}>
        <svg
          className="favorites-header-btn"
          width="30" 
          height="30"
          onClick={() => setShowDeletePlaylistPopup(true)}
          onMouseEnter={(e) => e.target.style.stroke = 'var(--button-hover)'}
          onMouseLeave={(e) => e.target.style.stroke = 'var(--button-color)'}
          viewBox="0 0 24 24"
          fill="none"
          style={{cursor: 'pointer'}}
        >
          <path d="M10 12V17" stroke="var(--button-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M14 12V17" stroke="var(--button-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M4 7H20" stroke="var(--button-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10" stroke="var(--button-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke="var(--button-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      {watchlistData?.map((playlist, index) => {
        const categoryData = {
          category_name: playlist?.title,
          shows: playlist?.shows,
          type: "WATCHLIST",
          show_all_needed: (playlist?.shows?.length || 0) > rowItemCountNumber,
          key: `playlist_${playlist?.playlist_id}`,
          thumbnail_orientation:
            projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION,
          playlist_id: playlist?.playlist_id,
          playlistData: playlist,
        };

        return (
          <Categories
            key={index}
            data={categoryData}
            fromFavoritesScreen={true}
          />
        );
      })}

      {watchlistData?.length === 0 && (
        <div className="favourite-empty-state">
          <h2><Translate text="no_data_found" /></h2>
        </div>
      )}
    </div>
  );
}

export default Favorites;
